import React, {Component} from 'react'
import styles from './InfoText.css'
import PropTypes from 'prop-types'

class InfoText extends Component {
  static propTypes = {
    data: PropTypes.string
  }
  

  render() {
    const {data} = this.props

    return (
      <div className={styles.InfoText}>
        <div
          className={styles.border}
          dangerouslySetInnerHTML={{__html: data}}
        />
      </div>
    )

    /*return (
      <div className={styles.InfoText}>
        <div className={styles.border}>
          <h4>Åbningstider</h4>
          <p>
            <span>Tirsdag – Søndag 10:00 – 18:00</span><br/>
            <span>Onsdag 10:00 – 20:00</span><br/>
            <span>Mandag Lukket</span><br/>
            <span>Særåbent 21. april.</span><br/><br/>
            <a href="">Læs mere</a>
          </p>

          <br/>

          <h4>Entré</h4>
          <p>
            <span>Voksen 120 kr.</span><br/>
            <span>Unge u. 27 år 95 kr.</span><br/>
            <span>En voksen + et barn 100 kr.</span><br/>
            <span>Børn u. 18 år Gratis</span><br/>
            <span>Årskort Fri entré</span><br/><br/>
            <a href="">Læs mere</a>
          </p>
        </div>
      </div>
    )*/
  }
}

export default InfoText



// WEBPACK FOOTER //
// ./src/components/Menu/InfoText.js